import React, { useCallback, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import Loading from "../../Components/loading";
import DraggableCode from "./DraggableCode";
import { useNavigate, useSearchParams } from "react-router-dom";
import bgImage from "../../assets/images/bg-img.jpg";
import { FaSave } from "react-icons/fa";

import toast from "react-hot-toast";

const SetUpCoding = () => {
  const defaultQuestions = [];

  const [loading, setLoading] = useState(false);
  const [regenLoading, setRegenLoading] = useState(false);
  const [apiCall, setApiCall] = useState(1);
  const [position, setPosition] = useState();
  const [minExperience, setMinExperience] = useState();
  const [maxExperience, setMaxExperience] = useState();
  const [technologies, setTechnologies] = useState();
  const [dummyGeneratedQuestions, setDummyGeneratedQuestions] = useState([]);
  const [shouldReset, setShouldReset] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const candidateID = searchParams.get("candidate_id");
  const [questions, setQuestions] = useState(defaultQuestions);
  const [customQuestions, setCustomQuestions] = useState([]);
  const [generateMoreQuestions, setGenerateMoreQuestions] = useState([]);
  const [showRegenerate, setShowRegenerate] = useState(false);
  const [showSave, setShowSave] = useState(false);

  // const [isSaveClicked, setIsSaveClicked] = useState(false);
  const navigate = useNavigate();

  // const nextStep = () => {
  //   if (id) {
  //     navigate(`/setup-coding?id=${id}`);
  //   }
  // };

  const prevStep = () => {
    if (id) {
      navigate(`/setup-interview?id=${id}`);
    }
  };

  useEffect(() => {
    if (shouldReset) {
      resetQuestions();
    }
  }, [shouldReset]);

  function generateHashSession() {
    const now = new Date();

    // Format: YYYY-MM-DD_HH-MM-SS
    const timestamp = now.toISOString().replace(/[-:.TZ]/g, "_");

    // Generate a random number for uniqueness
    const randomPart = Math.floor(Math.random() * 1e12);

    return `${timestamp}_${randomPart}`;
  }

  const addCustomQuestion = () => {
    setCustomQuestions([]);
    setGenerateMoreQuestions([
      ...generateMoreQuestions,
      ...customQuestions,
      { question: "" },
    ]);
    setShowRegenerate(true);
  };

  const removeCustomQuestion = (index) => {
    const updatedQuestions = customQuestions.filter((_, idx) => idx !== index);
    setCustomQuestions(updatedQuestions);
  };

  const addGenerateMoreQuestions = (dummyQuestions) => {
    console.log(dummyQuestions, "*****dummyGeneratedQuestions*****");
    console.log([...generateMoreQuestions, ...dummyQuestions]);

    dummyQuestions
      ? setGenerateMoreQuestions([...generateMoreQuestions, ...dummyQuestions])
      : setGenerateMoreQuestions([
          ...generateMoreQuestions,
          ...dummyGeneratedQuestions,
        ]);

    setTimeout(() => {
      console.log(
        generateMoreQuestions,
        "*****generateMoreQuestions log timeout*****"
      );
    }, 9000);
  };

  const handleCustomChange = (index, field, value, type) => {
    const updatedQuestions = [
      ...(type === "custom" ? customQuestions : generateMoreQuestions),
    ];
    updatedQuestions[index][field] = value;
    if (type === "custom") {
      setCustomQuestions(updatedQuestions);
    } else {
      setGenerateMoreQuestions(updatedQuestions);
    }
    setShowRegenerate(true);
  };

  const GenerateCodingQuestions = async () => {
    setLoading(true);
    try {
      const data = {
        input_content: `Create a practical coding exam for  ${
          position ? position : "software Engineer"
        } a requiring ${
          technologies ? technologies : "React and Node.js"
        },designed for candidates role (${minExperience ? minExperience : "2"} - ${
          maxExperience ? maxExperience : "5"
        } years of experience). Important: Do NOT include any MCQs, theory, or descriptive questions. 
        Include ONLY real-world coding tasks that require candidates to write working code.
        Each task should test practical problem-solving, integration, and best practices.
        Clearly state requirements, constraints, deliverables, and evaluation criteria.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_coding_question`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      setDummyGeneratedQuestions(response?.data?.problem_statement);
      console.log(dummyGeneratedQuestions, "*****dummyGeneratedQuestions*****");

      // addGenerateMoreQuestions(response?.data?.problem_statement);
      addGenerateMoreQuestions(
        Array.isArray(response?.data?.problem_statement)
          ? response?.data?.problem_statement
          : [{ question: response?.data?.problem_statement }]
      );

      setShowRegenerate(true);
      console.log(response, "****response*****");
      setApiCall(apiCall + 1);
    } catch (error) {
      console.log(error, "*****Error******");
      toast.error("Failed to fetch coding questions", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setLoading(false);
      setShowSave(true);
    }
  };

  const regenerateCodingQuestions = async () => {
    setRegenLoading(true);
    try {
      setDummyGeneratedQuestions([]);
      setGenerateMoreQuestions([]);

      const data = {
        input_content: `Create a practical coding exam for  ${
          position ? position : "software Engineer"
        } a requiring ${
          technologies ? technologies : "React and Node.js"
        },designed for candidates role (${minExperience ? minExperience : "2"} - ${
          maxExperience ? maxExperience : "5"
        } years of experience). Important: Do NOT include any MCQs, theory, or descriptive questions. 
        Include ONLY real-world coding tasks that require candidates to write working code.
        Each task should test practical problem-solving, integration, and best practices.
        Clearly state requirements, constraints, deliverables, and evaluation criteria.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_coding_question`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      setDummyGeneratedQuestions(
        Array.isArray(response?.data?.problem_statement)
          ? response?.data?.problem_statement
          : [{ question: response?.data?.problem_statement }]
      );
      setGenerateMoreQuestions(
        Array.isArray(response?.data?.problem_statement)
          ? response?.data?.problem_statement
          : [{ question: response?.data?.problem_statement }]
      );
      setApiCall(apiCall + 1);
    } catch (error) {
      console.error(error, "*****Error in Regenerating Questions*****");
      toast.error("Failed to regenerate coding questions", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setRegenLoading(false);
      setShowSave(true);
    }
  };

  const removeGeneratedQuestion = (index) => {
    const updatedQuestions = generateMoreQuestions.filter(
      (_, idx) => idx !== index
    );
    setGenerateMoreQuestions(updatedQuestions);
  };

  const resetQuestions = () => {
    setDummyGeneratedQuestions([]);
    setGenerateMoreQuestions([]);
    setShowRegenerate(false);
    setShouldReset(false);
  };
  const moveQuestion = useCallback((fromIndex, toIndex) => {
    setGenerateMoreQuestions((prev) => {
      const updatedQuestions = [...prev];
      const [movedItem] = updatedQuestions.splice(fromIndex, 1);
      updatedQuestions.splice(toIndex, 0, movedItem);
      return updatedQuestions;
    });
  }, []);

  useEffect(() => {
    getJob();
  }, []);

  const getJob = async () => {
    try {
      setLoading(true);
      console.log(id);

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_job?jd_id=${id}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }
      );
      setMaxExperience(response?.data?.job?.max_experience);
      setMinExperience(response?.data?.job?.min_experience);
      setPosition(response?.data?.job?.job_title);
      setTechnologies(response?.data?.job?.required_skills);
      console.log("Job Data:", response.data);
    } catch (err) {
      console.error("Error fetching job:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCodingQuestions();
  }, []);

  const getCodingQuestions = async () => {
    try {
      setLoading(true);
      console.log(id);

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_coding_question?jd_id=${id}`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      console.log(response, "*****Response*****");

      setGenerateMoreQuestions([{ question: response?.data?.question }]);
      setShowRegenerate(true);
      console.log(response, "*******Response*********");
    } catch (err) {
      console.error("Error fetching question:", err);
    } finally {
      setLoading(false);
      setShowSave(true);
    }
  };

  const AddQueAns = async () => {
    const payload = {
      problem_statement: generateMoreQuestions,
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/save_coding_question?jd_id=${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      // setIsSaveClicked(true);
    } catch (error) {
      toast.error(
        error?.response?.data?.error
          ? error?.response?.data?.error
          : "Something went wrong",
        {
          style: { backgroundColor: "red", color: "white" },
        }
      );
      console.error("Error while saving coding questions:", error);
    } finally {
      setLoading(false);
      setShowSave(false);
    }
  };

  console.log(generateMoreQuestions, "*****generateMoreQuestions*****");

  return (
    <>
      {(loading || regenLoading) && <Loading />}
      <div
        className="px-6  pt-6 pb-10 min-h-[calc(100vh-80px)]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex justify-end gap-4 ">
          <span className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-3 rounded-lg shadow-md">
            Total Questions :{" "}
            {questions.length +
              customQuestions.length +
              generateMoreQuestions.length}
          </span>
        </div>

        <h2 className="text-2xl font-semibold my-6 text-white text-left">
          Set-Up Coding Questions :
        </h2>

        <AnimatePresence>
          {generateMoreQuestions.map((item, index) => (
            <DraggableCode
              key={item.id || index}
              id={item.id || index}
              index={index}
              question={item?.question}
              moveQuestion={moveQuestion}
              onChange={handleCustomChange}
              remove={removeGeneratedQuestion}
            />
          ))}
        </AnimatePresence>

        <AnimatePresence>
          {customQuestions.map((item, index) => {
            const questionNumber =
              questions.length + generateMoreQuestions.length + index + 1;
            return (
              <motion.div
                key={index}
                className="flex gap-4 w-full items-center mt-4 bg-white p-4 shadow-lg rounded-lg"
              >
                <span className="text-gray-700 font-medium">
                  {questionNumber}.
                </span>
                <textarea
                  placeholder="Enter question"
                  value={item.question}
                  onChange={(e) =>
                    handleCustomChange(
                      index,
                      "question",
                      e.target.value,
                      "custom"
                    )
                  }
                  className="w-1/2  px-4 py-2 border rounded-lg h-20"
                />
                <motion.button
                  onClick={() => removeCustomQuestion(index)}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow-md  "
                >
                  Remove
                </motion.button>
              </motion.div>
            );
          })}
        </AnimatePresence>

        <div className="flex items-center gap-4 mt-6">
          <motion.button
            onClick={addCustomQuestion}
            className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md"
            draggable
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Add Custom Question
          </motion.button>

          {generateMoreQuestions && !generateMoreQuestions?.length > 0 && (
            <motion.button
              onClick={GenerateCodingQuestions}
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={loading}
            >
              <i class="fa-solid fa-bolt"></i>
              {loading
                ? "Generating Coding Questions Through AI..."
                : "Generate Questions"}
            </motion.button>
          )}
          {showRegenerate && (
            <motion.button
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={regenerateCodingQuestions}
              disabled={regenLoading}
            >
              <i className="fa fa-redo"></i>
              {regenLoading
                ? "Re-Generating Coding Questions Through AI..."
                : "Re-Generate question"}
            </motion.button>
          )}

          {generateMoreQuestions && generateMoreQuestions.length > 0 && (
            <motion.button
              className="bg-red-600 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setShouldReset(true)}
            >
              <i className="fa fa-undo"></i> Reset
            </motion.button>
          )}
        </div>
        <div className="mt-10 flex justify-center">
          {questions.length +
            customQuestions.length +
            generateMoreQuestions.length >
            0 &&
            showRegenerate &&
            showSave && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={AddQueAns}
              >
                <FaSave />
                Save
              </motion.button>
            )}
        </div>
        <div className=" p-2 flex justify-between items-center fixed bottom-8 left-0 right-0">
          <button
            className={`flex items-center gap-2 px-5 py-2  text-white rounded-lg font-medium transition-all bg-blue-700 hover:bg-blue-800`}
            onClick={prevStep}
          >
            <i className="fa fa-arrow-left"></i> Previous
          </button>

          {/* <div className="flex gap-2">
            <motion.button
              className={`flex items-center gap-2 px-5 py-2 text-white  rounded-lg font-medium transition-all ${
                isSaveClicked
                  ? " bg-blue-700 hover:bg-blue-800"
                  : " bg-blue-400 cursor-not-allowed"
              }`}
              onClick={nextStep}
              disabled={!isSaveClicked}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Next <i className="fa fa-arrow-right"></i>
            </motion.button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SetUpCoding;
